<div class="mb-3">
  <app-field-title [titleInfo]="inputContent" [formControlObj]="formControlObj">
    <textarea
      style="white-space: pre-line"
      class="form-control"
      [formControl]="formControlObj"
      [name]="inputContent.inputContentTitle"
      [placeholder]="isOptionLoading ? 'Loading..' : ''"
    ></textarea>
  </app-field-title>
</div>
